import { ICyclePayload, IExtendedCycle, IQuestionnaireTemplate, IQuestionnaireTemplatePayload } from "src/common/types";
import { javaDateToJS } from "src/helpers";
import { getCall } from "src/services";

const mapCycle = (cycle: ICyclePayload): IExtendedCycle => ({
  ...cycle,
  completionDueDate: javaDateToJS(cycle.completionDueDate)
});

export const getCycle = (cycleId: string): Promise<IExtendedCycle> =>
  new Promise((resolve, reject) =>
    (getCall({ url: `/v1/feedback/cycle/${cycleId}` }) as Promise<ICyclePayload>)
      .then((cycle: ICyclePayload) => {
        resolve(mapCycle(cycle));
      })
      .catch(err => reject(err))
  );
export interface IFilter {
  property: string;
  type: string;
  value: string;
}
export interface ISort {
  direction: string;
  property: string;
}
export interface IFetchCyclesReqParams {
  page: number;
  pageSize: number;
  sort: { order: ISort[] } | null;
  filter: { filters: IFilter[] } | null;
}

export const getQuestionnaireTemplates = (): Promise<IQuestionnaireTemplate[]> =>
  new Promise((resolve, reject) =>
    (getCall({ url: "/v1/feedback/questionnaire-template" }) as Promise<IQuestionnaireTemplatePayload>)
      .then(({ entities: templates }) => resolve(templates))
      .catch(err => reject(err))
  );
